import { useEffect, useRef, type ReactNode } from "react";

/** Erro em tela cheia: a leitura para até o operador confirmar. */
export function AlertaErro({ mensagem, onFechar, detalhe }: { mensagem: string | null; onFechar: () => void; detalhe?: ReactNode }) {
  const botao = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (mensagem) botao.current?.focus();
  }, [mensagem]);
  if (!mensagem) return null;
  return (
    <div data-dialogo-aberto className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-6 bg-erro p-6 text-white" role="alertdialog" aria-modal="true">
      <p className="max-w-xl text-center font-sinal text-4xl font-bold leading-tight">{mensagem}</p>
      {detalhe && <div className="max-w-xl text-lg">{detalhe}</div>}
      <button ref={botao} type="button" onClick={onFechar}
        className="min-h-16 rounded-md bg-white px-10 text-xl font-bold text-erro">
        Entendi
      </button>
    </div>
  );
}

/** Caixa de confirmação para ações que mudam o estoque ou a fila. */
export function Confirmar({
  aberto, titulo, children, rotuloConfirmar, perigo = false, onConfirmar, onCancelar, ocupado = false,
}: {
  aberto: boolean; titulo: string; children?: ReactNode; rotuloConfirmar: string; perigo?: boolean;
  onConfirmar: () => void; onCancelar: () => void; ocupado?: boolean;
}) {
  if (!aberto) return null;
  return (
    <div data-dialogo-aberto className="fixed inset-0 z-40 flex items-end justify-center bg-tinta/60 p-4 sm:items-center" role="dialog" aria-modal="true">
      <div className="w-full max-w-lg rounded-lg border-2 border-tinta bg-chapa p-5">
        <h2 className="font-sinal text-2xl font-bold">{titulo}</h2>
        {children && <div className="mt-3 text-base">{children}</div>}
        <div className="mt-5 flex flex-wrap justify-end gap-2">
          <button type="button" onClick={onCancelar} className="min-h-12 rounded-md border-2 border-tinta px-5 font-semibold">Voltar</button>
          <button type="button" disabled={ocupado} onClick={onConfirmar}
            className={`min-h-12 rounded-md px-5 font-semibold text-white disabled:opacity-50 ${perigo ? "bg-erro" : "bg-tinta"}`}>
            {rotuloConfirmar}
          </button>
        </div>
      </div>
    </div>
  );
}
